// FETCH ALL PROPERTIES FROM COLOR DETAIL
export const FETCH_COLOR_DETAIL_REQUEST = 'FETCH_COLOR_DETAIL_REQUEST';
export const FETCH_COLOR_DETAIL_SUCCESS = 'FETCH_COLOR_DETAIL_SUCCESS';
export const FETCH_COLOR_DETAIL_FAILURE = 'FETCH_COLOR_DETAIL_FAILURE';

// FETCH ALL PROPERTIES FROM COLOR DETAIL
export const FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST = 'FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST';
export const FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS = 'FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS';
export const FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE = 'FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE';

// CREATE PROPERTIES FOR COLOR DETAIL
export const CREATE_COLOR_DETAIL_REQUEST = 'CREATE_COLOR_DETAIL_REQUEST';
export const CREATE_COLOR_DETAIL_SUCCESS = 'CREATE_COLOR_DETAIL_SUCCESS';
export const CREATE_COLOR_DETAIL_FAILURE = 'CREATE_COLOR_DETAIL_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COLOR_DETAIL = 'CREATE_USER_FORM_COLOR_DETAIL';

// UPDATE PROPERTIES FOR COLOR DETAIL
export const UPDATE_COLOR_DETAIL_REQUEST = 'UPDATE_COLOR_DETAIL_REQUEST';
export const UPDATE_COLOR_DETAIL_SUCCESS = 'UPDATE_COLOR_DETAIL_SUCCESS';
export const UPDATE_COLOR_DETAIL_FAILURE = 'UPDATE_COLOR_DETAIL_FAILURE';

// FETCH SINGLE COLOR
export const FETCH_SINGLE_COLOR_DETAIL_REQUEST = 'FETCH_SINGLE_COLOR_DETAIL_REQUEST';
export const FETCH_SINGLE_COLOR_DETAIL_SUCCESS = 'FETCH_SINGLE_COLOR_DETAIL_SUCCESS';
export const FETCH_SINGLE_COLOR_DETAIL_FAILURE = 'FETCH_SINGLE_COLOR_DETAIL_FAILURE';

// DELETE PROPERTIES FOR COLOR DETAIL
export const DELETE_COLOR_DETAIL_REQUEST = 'DELETE_COLOR_DETAIL_REQUEST';
export const DELETE_COLOR_DETAIL_SUCCESS = 'DELETE_COLOR_DETAIL_SUCCESS';
export const DELETE_COLOR_DETAIL_FAILURE = 'DELETE_COLOR_DETAIL_FAILURE';

//RESET FORM OF USER
export const RESET_USER_FORM_COLOR_DETAIL = 'RESET_USER_FORM_COLOR_DETAIL';

export const FETCH_COLOR_DETAIL_WITH_ID_REQUEST = 'FETCH_COLOR_DETAIL_WITH_ID_REQUEST';
export const FETCH_COLOR_DETAIL_WITH_ID_SUCCESS = 'FETCH_COLOR_DETAIL_WITH_ID_SUCCESS';
export const FETCH_COLOR_DETAIL_WITH_ID_FAILURE = 'FETCH_COLOR_DETAIL_WITH_ID_FAILURE';



export const FETCH_COLOR_SHADE_DYEING_REQUEST = 'FETCH_COLOR_SHADE_DYEING_REQUEST';
export const FETCH_COLOR_SHADE_DYEING_SUCCESS = 'FETCH_COLOR_SHADE_DYEING_SUCCESS';
export const FETCH_COLOR_SHADE_DYEING_FAILURE = 'FETCH_COLOR_SHADE_DYEING_FAILURE';

export const FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1 = 'FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1';
export const FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1 = 'FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1';
export const FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1 = 'FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1';